/**
 * Componente que se encarga de recibir las peticiones enviadas desde el componente de terceros
 * en el momento de crear, editar o eliminar los registros.  Esto con el fin de que se 
 * recarguen los datos de las tablas afectadas por las datatables.
 * JMM-2018-05-17
 */
//Componente
import { Component, OnInit } from '@angular/core';
//Enrutamiento
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-enrutamientoterceros',
  templateUrl: './enrutamientoterceros.component.html'
})
export class EnrutamientotercerosComponent implements OnInit {

  constructor(
    private route   : ActivatedRoute,
    private router  : Router,
    private http    : Http
  ) {}

  /**
   * Dentro de esta función se manejan los enrutamientos automáticos
   * hacia donde se enrutan las peticiones de cada componente.
   * JMM-2018-05-17
   */
  ngOnInit() 
  {
    let identificador = this.route.snapshot.paramMap.get('id');
    let idTercero = this.route.snapshot.paramMap.get('idTercero');
    let tipoTercero = this.route.snapshot.paramMap.get('tipoTercero');
    let paramTercero = this.route.snapshot.paramMap.get('param');

    //Se eliminan los datos de la sesion del storage
    localStorage.removeItem('idtercero');
    localStorage.removeItem('tipotercero');
  
    if (identificador == 'sucursales') {
      //Se guardan la activación del tab
      localStorage.setItem('tabSucursales', '1');
      this.router.navigate(['/main/terceros/tercero-editar/'+idTercero+'/'+tipoTercero+'/'+paramTercero], { replaceUrl: true });
    }

    if (identificador == 'contactos') {
      //Se guardan la activación del tab
      localStorage.setItem('tabContactos', '1');
      this.router.navigate(['/main/terceros/tercero-editar/'+idTercero+'/'+tipoTercero+'/'+paramTercero], { replaceUrl: true });
    }

    if (identificador == 'equipos') {
      //Se guardan la activación del tab
      localStorage.setItem('tabEquipos', '1');
      this.router.navigate(['/main/terceros/tercero-editar/'+idTercero+'/'+tipoTercero+'/'+paramTercero], { replaceUrl: true });
    }

    if (tipoTercero == 'Cliente') {
      
      this.router.navigate(['/main/terceros/Cliente'], { replaceUrl: true });
    }
    if (tipoTercero == 'Proveedor') {
      this.router.navigate(['/main/terceros/Proveedor'], { replaceUrl: true });
    }
    if (tipoTercero == 'Empleado') { 
      this.router.navigate(['/main/terceros/Empleado'], { replaceUrl: true });
    }

  }// .ngOnInit() 

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/enrutamientos/enrutamientoterceros/enrutamientoterceros.component.ts